import type { PreviewPanelsApiState } from './types';

export const initialState: PreviewPanelsApiState = {
	// Configured by the product to allow for nuances in how the
	// product handles opening and closing of the preview panel.
	closePanelSlot: () => {},
	openPanelSlot: () => {},

	// Configured when opening a panel.
	panel: null,
	width: 400,
	onOpen: () => {},
	onClose: () => {},
};
